import { BairroProvider } from '$providers/bairro';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-selecionar-bairro',
  templateUrl: 'selecionar-bairro.html',
})
export class SelecionarBairroPage {

  public keys: '';
  items: Array<any>;
  selected: any;

  constructor(private viewCtrl: ViewController, navParams: NavParams,
    bairroProvider: BairroProvider, viewProvider: ViewProvider) {
    this.items = [];
    bairroProvider.get().subscribe(
      (bairros) => { this.items = bairros; },
      (error) => {
        console.error('Não foi possível carregar os bairros. ' + error);
        viewProvider.showToastError('Não foi possível carregar os bairros.');
      }
    );

    this.selected = navParams.get('bairro');
  }

  public confirm(item) {
    this.viewCtrl.dismiss(item);
  }
}



// WEBPACK FOOTER //
// ./src/pages/selecionar-bairro/selecionar-bairro.ts